import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { useDispatch } from "react-redux"
import * as Actions from "../../../store/actions"
const ScreenShotDialog = (props) => {

    const dispatch = useDispatch()

    const [IsLoading, setIsLoading] = useState(false)

    function Upload() {
        setIsLoading(true)
        dispatch(Actions.SavingScreenShotOFpatient(props.ImageBase, () => setIsLoading(false))).then(() => {
            setIsLoading(false)
      
        })
        props.close()
    }

    return (
        <Modal
            centered
            isOpen={props.open}
            toggle={() => props.close()}
            size="lg"
        >
            <ModalHeader toggle={() => props.close()}>Save screenshot?</ModalHeader>
            <ModalBody style={{ height: "300px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <img
                    className="img-fluid"
                    src={props.ImageBase}
                    style={{ height: "95%", boxShadow: "-1px 2px 19px 0px rgba(0,0,0,0.75)" }}
                />
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={() => props.close()}>Cancel</Button>{' '}
                <Button color="primary" onClick={() => Upload()}>
                    {
                        IsLoading ? "Loading..." : "Save"
                    }
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default ScreenShotDialog
